import { BareActionContext } from 'vuex-typex'
import { StatementState } from '../state'
import { RootState } from '../..'
import { IStatement } from '@/model/statement'
import statementStore from '../statement-store'

export default async function copyStatement(context: BareActionContext<StatementState, RootState>, statement: IStatement)
{
    statementStore.commitCopyStatement({ statement: statement })

    return
}
